(function ($) {
    'use strict';

    if (typeof wc_add_to_cart_params === 'undefined') {
        return false;
    }

    $(document).on('submit', 'form.cart, form.po-buy-form', function (e) {
        var $form = $(this),
            $button = $form.find('.single_add_to_cart_button, .po-buy'),
            product_id = $button.val() || $form.find('input[name="add-to-cart"]').val();

        if (!product_id || $form.parents('.cart-empty').length) {
            return;
        }

        e.preventDefault();

        var form_data = $form.serializeArray();
        
        // Remove 'add-to-cart' to prevent WooCommerce from processing it twice 
        // (once by default WC handler and once by our AJAX handler)
        form_data = form_data.filter(function(item) {
            return item.name !== 'add-to-cart';
        });

        form_data.push({ name: 'product_id', value: product_id });

        // Add ajax action
        form_data.push({ name: 'action', value: 'spraga_ajax_add_to_cart' });

        $button.removeClass('added').addClass('loading');

        $.ajax({
            type: 'POST',
            url: spraga_obj.ajax_url,
            data: $.param(form_data),
            success: function (response) {
                if (!response) {
                    return;
                }

                if (response.error && response.product_url) {
                    window.location = response.product_url;
                    return;
                }

                if (typeof wc_fragments_params !== 'undefined') {
                    $(document.body).trigger('wc_fragment_refresh');
                }

                if (response.product_info) {
                    var p = response.product_info;
                    var currency = p.currency || 'EUR'; // Fallback if missing, though PHP now sends it

                    var eventData = {
                        currency: currency,
                        value: p.price * p.quantity,
                        items: [{
                            item_id: p.item_id,
                            item_name: p.item_name,
                            price: p.price,
                            quantity: p.quantity,
                            item_variant: p.item_variant || '',
                            item_category: p.item_category || ''
                        }]
                    };

                    if (window._googlesitekit && typeof window._googlesitekit.gtagEvent === 'function') {
                        window._googlesitekit.gtagEvent('add_to_cart', eventData);
                    } else if (typeof window.gtag === 'function') {
                        window.gtag('event', 'add_to_cart', eventData);
                    }
                }

                $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $button, $button]);
                
                $button.removeClass('loading').addClass('added');
            },
            error: function (error) {
                console.log(error);
                $form.submit(); // Fallback to normal submit
            }
        });
    });

})(jQuery);
